const __default__ = {
  name: "MonthlyStudentTable",
  props: {
    student: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    days: {
      type: Number,
      default: 30
    },
    monthData: {
      type: Array,
      default: () => []
    },
    displayLabel: {
      type: String,
      default: ""
    }
  },

  data() {
    return {};
  },

  computed: {},
  methods: {
    handleCommentEdit(student) {
      this.$emit("handleCommentEdit", student);
    }

  }
};
import { useAbsentAlertStore } from "@/stores/absentAlert";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const absentAlertStore = useAbsentAlertStore();
    return {
      __sfc: true,
      absentAlertStore
    };
  }

});